/* SYNOR — popup behaviour. Markup and numbers: snippets/sa-signin-pop.liquid.
   Nothing here touches the bag, the checkout or any other script's state.

   THE CARDS NO LONGER COUNT MONEY DOWN TO ZERO. That animation belonged to
   cashback: ₹343 ticking to ₹0 said "all of it comes back". Cashback is off,
   so a number running down to nothing is simply a lie told with motion. The
   confetti is kept for the one moment that is still worth it: a shopper who
   has just signed in.

   ?sgp=now — A WAY TO LOOK AT IT.
   The popup is for shoppers who are not signed in, which makes it invisible
   to anyone who runs the shop: you sign in once and then cannot see your own
   popup again without a second browser. Adding sgp=now to any address opens
   it a second and a half in, whoever you are, and ignores the twice-a-visit
   limit. It does nothing without that word in the address, so no shopper
   ever meets it. */
(function () {
  var root = document.getElementById('sgp');
  if (!root || root.getAttribute('data-sg-ready')) return;
  root.setAttribute('data-sg-ready', '1');

  /* sgp=now STICKS for the rest of the browsing session. A theme preview
     drops the query string on the very next page, so without this the word
     has to be retyped on every page — which looks exactly like the popup
     having stopped working. Session-scoped: closing the tab clears it. */
  var PREVIEW = /[?&]sgp=now\b/.test(location.search);
  try {
    if (PREVIEW) sessionStorage.setItem('sgp_preview', '1');
    else if (sessionStorage.getItem('sgp_preview')) PREVIEW = true;
  } catch (e) {}

  var D = root.dataset;
  var FIRST = PREVIEW ? 1500 : (+D.first || 15) * 1000;
  var AGAIN = (+D.again || 180) * 1000;
  var MAX = PREVIEW ? 99 : (+D.max || 2);
  var VISIT = 'sgp_visit', WAIT = 'sgp_wait';
  var REDUCED = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  var sheet = root.querySelector('.sg-sheet');
  var main = root.querySelector('.sg-main');
  var done = root.querySelector('.sg-done');
  var pick = root.querySelector('[data-sg-pick]');
  if (pick && D['try']) pick.setAttribute('href', D['try']);

  function ss(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function kpId() { try { return localStorage.getItem('kp_customer_id') || ''; } catch (e) { return ''; } }
  function signedIn() {
    if (PREVIEW) return false;
    if (kpId()) return true;
    var g = document.getElementById('loggedin-icons');
    return !!g && getComputedStyle(g).display !== 'none';
  }

  /* ---------- visit state: shown count and when it may open next ---------- */
  var st = null;
  try { st = JSON.parse(ss(VISIT) || 'null'); } catch (e) {}
  if (!st || typeof st.shown !== 'number') { st = { shown: 0, next: Date.now() + FIRST }; }
  if (PREVIEW) { st = { shown: 0, next: Date.now() + FIRST }; }
  function save() { ss(VISIT, JSON.stringify(st)); }
  save();

  /* ---------- something else already on screen? then wait ---------- */
  function big(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.width > 120 && r.height > 120; }
  function busy() {
    if (document.hidden) return true;
    var frames = document.querySelectorAll('iframe');
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i], s = (f.getAttribute('src') || '') + ' ' + (f.id || '') + ' ' + (f.name || '');
      if (/gokwik|kwik/i.test(s) && big(f)) return true;           /* checkout or OTP window is open */
    }
    var h = document.documentElement.style.overflow, b = document.body.style.overflow;
    if (h === 'hidden' || b === 'hidden') return true;                /* a drawer or another sheet is open */
    return false;
  }

  /* ---------- confetti: kept for the sign-in moment only ---------- */
  var cv = null, cx = null, bits = [], raf = null;
  var COLORS = ['#BE9A54', '#E7CF95', '#F7F3EA', '#8C6B2E', '#0C6B52', '#FFF1CC'];
  function canvas() {
    if (cv) return;
    cv = document.createElement('canvas'); cv.className = 'sg-fx'; root.appendChild(cv);
    var d = window.devicePixelRatio || 1; cv.width = innerWidth * d; cv.height = innerHeight * d;
    cx = cv.getContext('2d'); cx.setTransform(d, 0, 0, d, 0, 0);
  }
  function burst(n, y, spread) {
    if (REDUCED) return;
    canvas(); var w = innerWidth;
    for (var i = 0; i < n; i++) {
      var L = i % 2 === 0;
      bits.push({ x: L ? w * .16 : w * .84, y: y, vx: (L ? 1 : -1) * (2 + Math.random() * spread) + (Math.random() - .5) * 2, vy: -(6 + Math.random() * 7),
        r: Math.random() * 3, vr: (Math.random() - .5) * .35, s: 5 + Math.random() * 6, k: Math.random() < .35 ? 0 : (Math.random() < .5 ? 1 : 2),
        c: COLORS[(Math.random() * COLORS.length) | 0], life: 0, max: 100 + Math.random() * 60, wob: Math.random() * 6 });
    }
    if (!raf) raf = requestAnimationFrame(tick);
  }
  function tick() {
    cx.clearRect(0, 0, innerWidth, innerHeight);
    for (var i = bits.length - 1; i >= 0; i--) {
      var b = bits[i];
      b.life++; b.vy += .28; b.vx *= .985; b.vy *= .985; b.x += b.vx + Math.sin((b.life + b.wob) / 9) * .6; b.y += b.vy; b.r += b.vr;
      var a = Math.max(0, 1 - b.life / b.max);
      if (a <= 0 || b.y > innerHeight + 30) { bits.splice(i, 1); continue; }
      cx.save(); cx.globalAlpha = a; cx.translate(b.x, b.y); cx.rotate(b.r); cx.fillStyle = b.c;
      if (b.k === 0) { cx.beginPath(); cx.arc(0, 0, b.s * .38, 0, 7); cx.fill(); }
      else if (b.k === 1) { cx.beginPath(); cx.ellipse(0, 0, b.s * .55, b.s * .25, 0, 0, 7); cx.fill(); }
      else { cx.fillRect(-b.s / 2, -b.s * .18, b.s, b.s * .36 * Math.abs(Math.cos(b.life / 7)) + 1); }
      cx.restore();
    }
    if (bits.length) { raf = requestAnimationFrame(tick); }
    else { raf = null; if (cv) { cv.remove(); cv = null; cx = null; } }
  }

  /* ---------- the cards arrive ---------- */
  var T = [];
  function later(fn, ms) { T.push(setTimeout(fn, ms)); }
  function clearT() { T.forEach(clearTimeout); T = []; }
  function cards() {
    var one = root.querySelector('[data-sg-one]'), two = root.querySelector('[data-sg-seven]');
    if (!one || !two) return;
    one.classList.remove('in'); two.classList.remove('in');
    if (REDUCED) { one.classList.add('in'); two.classList.add('in'); return; }
    later(function () { one.classList.add('in'); }, 220);
    later(function () { two.classList.add('in'); }, 430);
  }

  /* ---------- open / close ---------- */
  var prevOverflow = null, timer = null, poll = null;
  function lock() { prevOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; }
  function unlock() { if (prevOverflow !== null) { document.documentElement.style.overflow = prevOverflow; prevOverflow = null; } }

  /* Never open on to a sheet that is not actually there. A stylesheet
     elsewhere once hid it, and the page blurred behind nothing. */
  function drawable() {
    if (!sheet) return false;
    var cs = getComputedStyle(sheet);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  function show(win) {
    root.hidden = false;
    main.hidden = !!win; done.hidden = !win;
    root.classList.toggle('win', !!win);
    if (!drawable()) { root.hidden = true; return false; }
    lock();
    void root.offsetWidth;
    root.classList.add('on');
    try { sheet.focus({ preventScroll: true }); } catch (e) {}
    return true;
  }
  function hide() {
    clearT();
    root.classList.remove('on');
    unlock();
    setTimeout(function () { if (!root.classList.contains('on')) root.hidden = true; }, 420);
  }

  function open() {
    if (signedIn()) return;
    if (st.shown >= MAX) return;
    if (busy()) { timer = setTimeout(open, 20000); return; }
    if (!show(false)) return;
    st.shown++; save();
    cards();
  }
  function plan() {
    clearTimeout(timer);
    if (st.shown >= MAX || signedIn()) return;
    timer = setTimeout(open, Math.max(PREVIEW ? 300 : 1200, st.next - Date.now()));
  }
  function dismiss() {
    var wasWin = root.classList.contains('win');
    hide();
    if (wasWin) return;
    if (st.shown < MAX) { st.next = Date.now() + AGAIN; save(); plan(); }
  }
  function win() {
    ss(WAIT, null); clearTimeout(timer); clearInterval(poll);
    if (show(true)) burst(90, innerHeight * .45, 7);
  }

  /* ---------- sign in: KwikPass's own window, same as the Account tab ---------- */
  function login() {
    hide();
    ss(WAIT, '1');
    var opened = false;
    if (typeof window.kpHandleLogin === 'function') { try { window.kpHandleLogin(); opened = true; } catch (e) {} }
    if (!opened) { var t = document.getElementById('icon-kwikpass'); if (t) { t.click(); opened = true; } }
    if (!opened) { window.location.href = '/account/login'; return; }
    clearInterval(poll);
    var until = Date.now() + 5 * 60 * 1000;
    poll = setInterval(function () {
      if (signedIn()) { win(); return; }
      if (Date.now() > until) clearInterval(poll);
    }, 1500);
    if (st.shown < MAX) { st.next = Date.now() + AGAIN; save(); plan(); }
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-sg-login]')) { e.preventDefault(); login(); return; }
    if (t.closest('[data-sg-close]')) { e.preventDefault(); dismiss(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('on')) dismiss(); });

  /* ---------- start ---------- */
  function start() {
    if (ss(WAIT) && signedIn()) { setTimeout(win, 900); return; }   /* came back signed in */
    if (signedIn()) return;
    plan();
  }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();
